"use client";
import { createContext, useContext, useState } from "react";
import { NotificationGlobalContextType } from "@/types/NotificationTypes";
import { ModalContextType } from "@/types/ModalTypes";

interface InformationContextType {
  notification: NotificationGlobalContextType | null;
  setNotification: (notification: NotificationGlobalContextType | null) => void;
  modal: ModalContextType | boolean;
  setModal: (modal: ModalContextType | boolean) => void;
  hasConversations: boolean;
  setHasConversations: (hasConversations: boolean) => void;
  isTrainingInFullScreen: boolean;
  setIsTrainingInFullScreen: (isTrainingInFullScreen: boolean) => void;
}

const InformationContext = createContext<InformationContextType | undefined>(
  undefined
);

export const InformationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [notification, setNotification] =
    useState<NotificationGlobalContextType | null>(null);
  const [modal, setModal] = useState<ModalContextType | boolean>(false);
  const [hasConversations, setHasConversations] = useState(false);
  // is training in full screen mode on mobile
  const [isTrainingInFullScreen, setIsTrainingInFullScreen] =
    useState<boolean>(false);

  return (
    <InformationContext.Provider
      value={{
        notification,
        setNotification,
        modal,
        setModal,
        hasConversations,
        setHasConversations,
        isTrainingInFullScreen,
        setIsTrainingInFullScreen,
      }}
    >
      {children}
    </InformationContext.Provider>
  );
};

export const useInformation = () => {
  const context = useContext(InformationContext);
  if (context === undefined) {
    throw new Error(
      "useInformation must be used within an InformationProvider"
    );
  }
  return context;
};
